'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PasswordPolicySection } from '@/features/identity-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/password/')({
  component: PasswordSettingsPage
});
function PasswordSettingsPage() {
  return <PasswordPolicySection editTo="/settings/authentication/settings/password/edit" />;
}